// Module
var code = "<react-component name=\"WaiversList\"></react-component>\n";
// Exports
module.exports = code;